import * as RadixForm from "@radix-ui/react-form";
import { Text } from "@radix-ui/themes";
import { FieldMetadata } from "@conform-to/react";

export const ValidationMessage = ({ field }: { field: FieldMetadata }) => {
  const errors = field.errors;
  if (!errors) {
    return null;
  }

  return (
    <RadixForm.Message>
      {errors.map((e) => (
        <Text key={e} color="red">
          {e}
        </Text>
      ))}
    </RadixForm.Message>
  );
};
